import {format} from 'date-fns'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

class PPDateFnsUtilsForYMD extends AdapterDateFns {
    getDatePickerHeaderText(date: Date): string {
        return ''
    }

    getCalendarHeaderText(date: Date): string {
        return format(date, 'yyyy年 M月', {locale: this.locale})
    }

    getYearText = (date: Date): string => {
        return date.getFullYear().toString()
    }
}

export default PPDateFnsUtilsForYMD
